import { z } from 'zod';
import { apiClient } from '@api/client';
import { imageUploadSchema, type ImageUpload } from './schema';

const responseSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  data: imageUploadSchema.nullable(),
  error: z.string().nullable().optional(),
});

// Folders the API accepts. Mirror of `ALLOWED_IMAGE_FOLDERS` server-side —
// keep both lists in sync when a new module starts uploading images.
export const IMAGE_FOLDERS = ['news', 'crops', 'varieties'] as const;
export type ImageFolder = (typeof IMAGE_FOLDERS)[number];

export async function uploadImage(
  file: File,
  folder: ImageFolder,
): Promise<ImageUpload> {
  const form = new FormData();
  form.append('file', file);
  // Strip the client's default `application/json` so axios + the browser set
  // `multipart/form-data; boundary=...` themselves. Setting it to a fixed
  // string would omit the boundary and break Fastify's multipart parser.
  const response = await apiClient.post('/images/upload', form, {
    params: { folder },
    headers: { 'Content-Type': undefined },
  });
  const parsed = responseSchema.safeParse(response.data);
  if (!parsed.success || !parsed.data.data) {
    throw new Error(parsed.success ? 'Empty upload response' : parsed.error.message);
  }
  return parsed.data.data;
}
